import { ConfirmBundleOrderComponent } from './../confirm-bundle-order/confirm-bundle-order.component';
import { MatDialog } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { Utils } from '../../../utils/Utils';
import { CryptoService } from 'src/app/pages/core/abstraction/crypto.service';
import { AuthService } from 'src/app/pages/core/abstraction/auth.service';
import { ICryptoBundle, ICryptoPrice, COIN_FULL_NAME } from '../../../models/Crypto';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import {
  AlertDialogComponent,
  AlertDialogData,
} from 'src/app/modules/shared/components/dialogs/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-crypto-bundle-detail-card',
  templateUrl: './crypto-bundle-detail-card.component.html',
  styleUrls: ['./crypto-bundle-detail-card.component.scss'],
})
export class CryptoBundleDetailCardComponent implements OnInit {
  @Input() bundle: ICryptoBundle;
  @Input() isArsCurrency = true;
  @Input() variation = 0;

  @Output() closeEvent: EventEmitter<void> = new EventEmitter();
  @Output() changeCurrency: EventEmitter<number> = new EventEmitter();

  @ViewChild('bigTile') bigTile;
  @ViewChild('tile') tile;
  @ViewChild('icon') icon;

  isBuying = false;
  operateQuantity: FormControl = new FormControl('');
  currency = 'ARS';
  creatingOrder = false;
  bundleMinAmount: number;
  prices = {};
  hovered = false;
  hoveredIndex: number;
  isMaxOperation = false;
  hoveredTicker = '';
  ticker = '';

  isBuyingDisabled = true;

  constructor(
    public authService: AuthService,
    public cryptoService: CryptoService,
    public dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.ticker = this.bundle?.ticker;
    this.cryptoService.prices.subscribe((prices) => {
      this.prices = prices;
    });
    this.cryptoService
      .getBundleMinAmount(this.bundle.ticker + '_' + this.currency)
      .subscribe((res) => {
        this.bundleMinAmount = res.price;
      });

    // if (this.bundle.coins.findIndex(({ ticker }) => ticker === 'LUNA' || ticker === 'UST') !== -1)
    //   this.isBuyingDisabled = true;
  }

  getAvailableFund() {
    if (this.isBuying) {
      return Utils.roundDown(this.authService.loggedUser.balance.fiat[this.currency]);
    } else {
      return (
        Utils.roundDown(
          this.cryptoService.getFiatValueByBundle(this.bundle.ticker, this.currency),
        ) || 0
      );
    }
  }

  colorPaletteByBundle(ticker, type) {
    const palette = {
      'BNDL-RCHAIN': { main: '#960505', accent: '#FFFFFF', circle: '#FFFFFF' },
      'BNDL-RMETA': { main: '#DCA1F5', accent: '#880094', circle: '#880094' },
      'BNDL-CONS': { main: '#B5AFE6', accent: '#423A7F', circle: '#FFFFFF' },
      'BNDL-INTR': { main: '#FFFFFF', accent: '#000000', circle: '#000000' },
      'BNDL-RFUT': { main: '#5ECD9E', accent: '#000000', circle: '#FFFFFF' },
    };
    return palette[ticker][type];
  }

  getCoinFullName(ticker: string) {
    return COIN_FULL_NAME[ticker];
  }

  getIconSrc(coinTicker: string, index: number) {
    if (this.ticker === 'BNDL-CONS' || this.ticker === 'BNDL-RFUT') {
      return (
        '/assets/icons/crypto/bundles/inside/' + coinTicker.toLowerCase() + this.ticker + '.svg'
      );
    } else {
      return (
        '/assets/icons/crypto/bundles/inside/' +
        coinTicker.toLowerCase() +
        this.ticker +
        '_' +
        (this.hovered && index === this.hoveredIndex ? 'accent' : 'main') +
        '.svg'
      );
    }
  }

  getCoinPercentage(ticker) {
    if (ticker) {
      return this.bundle.coins.find((coin) => coin.ticker === ticker).percentage * 100 || 0;
    } else {
      return 0;
    }
  }

  getIconPosition(lenght, index) {
    const positions = {
      3: {
        0: { top: '5%', left: 'calc(50% - 17.5px)' },
        1: { bottom: '32%', right: '45%' },
        2: { bottom: '32%', left: '45%' },
      },
      4: {
        0: { top: '30%', right: '45%' },
        1: { top: '30%', left: '45%' },
        2: { bottom: '32%', right: '45%' },
        3: { bottom: '32%', left: '45%' },
      },
    };
    return positions[lenght][index];
  }

  getSVGDeg(length, index) {
    const deg = {
      3: {
        0: '0deg',
        1: '180deg',
        2: '90deg',
      },
      4: {
        0: '-90deg',
        1: '0deg',
        2: '180deg',
        3: '90deg',
      },
    };
    return `rotate(${deg[length][index]})`;
  }

  getValueByTicker(ticker, percentage) {
    const price = this.prices[ticker + '_' + this.currency][this.isBuying ? 'buy' : 'sell'];
    return (this.operateQuantity.value.replace('.', '').replace(',', '.') * percentage) / price;
  }

  getBundleDescription(ticker) {
    const descriptions = {
      'BNDL-CONS': `Esta canasta contiene a las 2 criptos de mayor capitalizacion e importancia del mercado como Ethereum y Bitcoin. Para mitigar la volatilidad, se agrega aUST, token que representa los depósitos de UST con una capitalización continua.`,
      'BNDL-RFUT': `Esta canasta está compuesta por los tokens de equipos de fútbol. La componen los tokens de PSG, Atlético de Madrid, Barcelona y el City. Ideal para amantes de la redonda.`,
      'BNDL-RCHAIN': `Esta canasta esta compuesta por las criptos nativas de las cuatro de las principales blockchains en la actualidad: Luna, Solana, Binance Coin y Ethereum. Estas blockchains son independientes entre sí y cada una tiene sus propias características.`,
      'BNDL-RMETA': `Esta canasta esta compuesta por Axs, Mana, Enjin Coin, Sandbox. Cada moneda es independiente entre sí y el objetivo de cada proyecto es el armado de un metaverso.`,
      'BNDL-INTR': `Esta canasta contiene a las 2 criptos de mayor capitalizacion e importancia del mercado como Ethereum y Bitcoin y se agrega BNB. Para mitigar la volatilidad, se agrega aUST, token que representa los depósitos de UST con una capitalización continua.`,
    };
    return descriptions[ticker];
  }

  createOrder() {
    if (this.creatingOrder) return;
    this.creatingOrder = true;

    if (!this.validateIfCanOperate()) {
      this.creatingOrder = false;
      return;
    }

    const coinsTickers = this.bundle.coins.map((coin) => coin.ticker + '_' + this.currency);
    const operation = this.isBuying ? 'BUY' : 'SELL';
    const value = this.operateQuantity.value.replace(',', '.');
    const coinsAmounts = this.bundle.coins.reduce(
      (obj, coin) => (
        (obj[coin.ticker] = this.getValueByTicker(coin.ticker, coin.percentage)), obj
      ),
      {},
    );
    let lockedBundle;

    const obs = this.cryptoService.lockBundleOrder(coinsTickers, operation);
    obs.subscribe((res) => {
      lockedBundle = res;
      const prices = coinsTickers.reduce(
        (obj, coin) => ((obj[coin] = lockedBundle.locks[coin].price), obj),
        {},
      );
      this.dialog
        .open(ConfirmBundleOrderComponent, {
          maxWidth: '100vw',
          panelClass: 'modal-container',
          data: {
            ticker: this.ticker,
            name: this.bundle.name,
            operation,
            fiatAmount: value,
            coins: this.bundle.coins,
            coinsTickers,
            coinsAmounts,
            prices,
            lockedBundle: res,
            lockedBundleObs: obs,
            currency: this.currency,
            isMaxOperation: this.isMaxOperation,
            options: ['Aceptar'],
          },
        })
        .afterClosed()
        .subscribe((res) => {
          this.creatingOrder = false;
          if (res) {
            this.closeExchangeForm();
          }
        });
    });
  }

  onQuantityChange() {
    this.isMaxOperation = false;
  }

  setMaxAmount() {
    this.isMaxOperation = true;
    this.operateQuantity.setValue(this.getAvailableFund().toString().replace('.', ','));
  }

  validateIfCanOperate() {
    const value = this.operateQuantity.value.replace(',', '.');

    if (!this.authService.checkOnboardingStatus()) return false;

    if (this.bundleMinAmount > value) {
      this.dialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
        panelClass: 'modal-container',
        data: {
          title: 'ERROR AL CREAR LA ORDEN',
          content: `El monto de la operación no supera el mínimo necesario.
          (${
            Utils.parseNumberToCurrencyString(Number(this.bundleMinAmount.toFixed(2))) || 0
          } ${this.currency.replace('S', '$')})`,
          isError: true,
        },
      });
      return false;
    }

    if (value > this.getAvailableFund()) {
      this.dialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
        panelClass: 'modal-container',
        data: {
          title: 'ERROR AL CREAR LA ORDEN',
          content: `No es posible realizar la orden por ${this.currency.replace(
            'S',
            '$',
          )} ${Utils.parseNumberToCurrencyString(
            parseFloat(Utils.parseCurrencryToNumber(value).toFixed(2)),
          )}
      No tenés fondos suficientes.
      `,
          isError: true,
        },
      });
      return false;
    }

    return true;
  }

  closeExchangeForm() {
    this.closeEvent.emit();
  }
}
